import React, { useCallback } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import styles from '../CreateRoute.module.scss';
import { getStopNumber } from '../constants/stopLabels';

/**
 * @param {{
 *   coordinate: [number, number],
 *   index: number,
 *   total: number,
 *   isSelected: boolean,
 *   isDrawFrom: boolean,
 *   label: string,
 *   onDragEnd: (index: number, e: any) => void,
 *   onClick: (index: number) => void,
 * }} props
 */
const WaypointMarker = ({ coordinate, index, total, isSelected, isDrawFrom, label, onDragEnd, onClick }) => {
  const isFirst = index === 0;
  const isLast  = index === total - 1;

  const handleClick   = useCallback(() => onClick(index), [index, onClick]);
  const handleDragEnd = useCallback((e) => onDragEnd(index, e), [index, onDragEnd]);
  const handleKeyDown = useCallback(
    (e) => { if (e.key === 'Enter' || e.key === ' ') onClick(index); },
    [index, onClick],
  );

  const markerClass = [
    styles.waypointMarker,
    isSelected  ? styles.waypointSelected  : '',
    isDrawFrom  ? styles.waypointDrawFrom  : '',
    isFirst     ? styles.waypointFirst     : '',
    isLast && !isFirst ? styles.waypointLast : '',
  ]
    .filter(Boolean)
    .join(' ');

  const stopNumber = getStopNumber(index);
  const roleLabel = isDrawFrom
    ? `Stop ${stopNumber} — drawing from here. Click map to add next stop.`
    : label?.trim()
      ? `Stop ${stopNumber}: ${label}`
      : `Stop ${stopNumber}${isFirst ? ' (Start)' : isLast ? ' (End)' : ''}`;

  return (
    <Marker
      longitude={coordinate[0]}
      latitude={coordinate[1]}
      anchor="center"
      draggable
      onDragEnd={handleDragEnd}
    >
      <div className={styles.waypointWrap}>
        {isDrawFrom && <span className={styles.drawFromRing} aria-hidden="true" />}
        <div
          className={markerClass}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex={0}
          aria-label={roleLabel}
          title={roleLabel}
        >
          {stopNumber}
        </div>
      </div>
    </Marker>
  );
};

export default WaypointMarker;
